import React from 'react';
import noServiceBgImg from '@/assets/image/no-service-bg.png';
import { Header } from '@/components';

import cx from './index.module.scss';

interface Props {}

const NoService: React.FC<Props> = () => {
  return (
    <div className={cx('no-service')}>
      <Header showBack={false} showBorder={false} />
      <div className={cx('img-box')}>
        <img src={noServiceBgImg} alt="no-service" />
        <div className={cx('no-service-text')}>当前无服务</div>
      </div>
    </div>
  );
};

export default NoService;
